<template>
  <el-drawer
    :visible.sync="active"
    size="300px"
    class="apex-table-columns-filter"
    :title="t('table.toolbar.combinationSort')"
    append-to-body
  >
    <div class="apex-drawer-wrapper">
      <!-- 全选 反选 -->
      <el-card shadow="never">
        <div class="component--list">
          <div key="__first__" class="component--list-item" style="padding: 10px">
            <span>Key</span>
            <span class="title">{{ t('table.toolbar.sortDrag') }}</span>
          </div>
          <el-scrollbar wrap-class="scrollbar-wrapper">
            <draggable v-model="currentValue" ghost-class="ghost" handle=".handle" :animation="200">
              <transition-group>
                <div v-for="(option, index) of currentValue" :key="option.key" class="component--list-item">
                  <span>{{ option.title || option.key || "未命名" }}</span>
                  <div class="set-wrapper">
                    <sort-controller v-model="currentValue[index].orderBy" />
                    <div class="component--list-item-handle handle">
                      <img src="../../img/drag.png" :title="t('table.toolbar.dragDropSort')">
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-scrollbar>
        </div>
      </el-card>
      <el-row class="drawer-footer" :gutter="10">
        <el-col :span="12">
          <el-button icon="el-icon-refresh" @click="reset">{{ t('table.toolbar.restore') }}</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-check" @click="confirm">{{ t('table.toolbar.confirm') }}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import locale from '@/mixins/index'
import draggable from 'vuedraggable'
import _clonedeep from 'lodash.clonedeep'
import sortController from './sort-controller'
import TableStore from '../utils/storage'

export default {
  name: 'ApexCombSort',
  components: {
    draggable,
    sortController
  },
  mixins: [locale],
  props: {
    options: {
      type: Array,
      default: () => [],
      required: false
    },
    value: {
      type: Array,
      default: () => [],
      required: false
    },
    storage: {
      type: [Boolean, String],
      default: true,
      required: false
    },
    storageNeedPrefix: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentValue: [],
      active: false
    }
  },
  watch: {
    options() {
      this.refresh()
    },
    value() {
      this.refresh()
    },
    active(value) {
      if (value === false) {
        this.refresh()
      }
    }
  },
  created() {
    let storedOptions = this.getOptionsFromStorage()
    if (storedOptions) {
      const storeHash = this.getColumnsHash(storedOptions)
      const optionHash = this.getColumnsHash(this.options)
      if (optionHash !== storeHash) {
        // 如果字段列有过修改，则不使用本地设置
        storedOptions = null
      }
    }
    this.storedOptions = storedOptions
    this.refresh()
    if (storedOptions) {
      this.submit('init')
    }
  },
  methods: {
    refresh() {
      const options = _clonedeep(this.options)
      const value = _clonedeep(this.value)
      const currentValue = []
      // 设置比较源
      let compareSource = options
      if (this.storedOptions != null) {
        compareSource = this.storedOptions
      }
      // 计算
      compareSource.forEach(option => {
        // 在 value 尝试找到这个项目
        // 没有的话使用 option 中的默认值
        let storeItem = null
        if (this.storedOptions != null) {
          storeItem = option
          option = options.find(column => column.key === option.key)
        }
        let item = value.find(column => column.key === option.key)
        // let show = item != null && item.show !== false
        item = item || option

        if (storeItem) {
          // 使用本地保存的设置
          // show = storeItem.show
          item.orderBy = storeItem.orderBy
        }
        // item.show = show
        currentValue.push(item)
      })
      this.currentValue = currentValue
    },
    // 开始选择
    start() {
      this.active = true
    },
    // Confirm保存
    confirm() {
      this.changeType = 'confirm'
      this.submit()
    },
    // 还原
    reset() {
      this.changeType = 'restore'
      this.currentValue = _clonedeep(this.options)
      this.submit('save')
      this.clearThisStorage()
    },
    // 确认
    submit(type) {
      const result = []
      this.currentValue.forEach((item, index) => {
        result.push(item)
      })
      if (type !== 'save') {
        this.saveOptionsToStorage(result)
      }
      if (type !== 'init') {
        this.emit(result)
      }
      this.active = false
    },
    emit(result) {
      this.$emit('input', result)
      this.$emit('change', result, this.changeType)
    },
    saveOptionsToStorage(value) {
      if (this.storage === false) {
        return
      }

      const storedOptions = []
      for (let i = 0; i < value.length; i++) {
        const item = value[i]
        const target = {
          key: item.key,
          title: item.title,
          orderBy: item.orderBy ? item.orderBy : ''
        }
        storedOptions.push(target)
      }
      this.storedOptions = storedOptions
      this.getStorageTable().updateTableValue(storedOptions)
    },
    getOptionsFromStorage() {
      if (this.storage === false) {
        return
      }
      return this.getStorageTable().getTableValue()
    },
    clearThisStorage() {
      this.getStorageTable().clearTableValue()
      this.storedOptions = null
    },
    getStorageTable() {
      if (this.StorageTableStore == null) {
        this.StorageTableStore = new TableStore({ $router: this.$route, tableName: 'combSort', keyType: this.storage, storageNeedPrefix: this.storageNeedPrefix })
      }
      return this.StorageTableStore
    },
    getColumnsHash(columns) {
      const keys = []
      for (const item of columns) {
        keys.push(item.key)
      }
      keys.sort()
      let hash = ''
      for (const key of keys) {
        hash += key
      }
      return hash
    }
  }
}
</script>

<style lang="scss">
.apex-table-columns-filter {
  :focus {
    outline: 0;
  }

  .scrollbar-wrapper {
    max-height: calc(100vh - 180px);
    padding-bottom: 4px;
  }

  .el-drawer__header {
    margin-bottom: 10px;
  }

  .apex-drawer-wrapper {
    padding: 10px;
  }

  .drawer-footer {
    padding: 20px;
    text-align: center;
    .el-button {
      padding: 12px 20px !important;
    }
  }

  .component--list {
    margin: -20px;

    .title {
      font-size: 14px;
    }
    .component--list-item {
      padding: 6px 10px;
      background-color: #fff;
      margin-bottom: 1px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.ghost {
        opacity: 0.8;
        background: #ecf5ff;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      .component--list-item-handle {
        padding: 0 6px;
        cursor: move;
        > img {
          width: 16px;
          height: 16px;
          transform: translateY(2px);
        }
      }
      .set-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      > span {
        max-width: 170px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        color: #606266;
      }
    }
  }
}
</style>
